import { render, staticRenderFns } from "./ResolvedTasksPage.vue?vue&type=template&id=6d717b3b"
import script from "./ResolvedTasksPage.vue?vue&type=script&lang=js"
export * from "./ResolvedTasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports